import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";


import SafeHtmlRenderer from "./SafeHtmlRenderer";
  
const QuestionRichContent= ({contentType,queRichContents})=>{ 
    const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
    
          const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
        const [isLoaded, setIsLoaded] = useState(false);
        const [hasError, setHasError] = useState(false);
        
           
                
                     
        return (
         
            <img
      
            
              src={ src}
              alt=""
             style={
                   {
                     
            top: 0,
            left: 0,
            width: `${width}%`,
           
            objectFit: "cover", }}
             className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
            />
          
        );
      };
      
   
   const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
        
     const [itemArr, setItemArr] = useState([]);
   
          const flattenedData = itemArr!=[]?Object.values(queRichContents):'';

  
  
 
     return(<>
             
    <div style={{zIndex:99,}} > 
       

     
   
                <div  className=" " >

  {flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.id}  style={{}}  >

            <div style={{padding:"10px"}}>  {item?.contentType==contentType?<>
   {item?.mimeType==""?  <SafeHtmlRenderer
      html={item?.contentFormatedText}
      className="content"
    />:
   item?.mimeType=="image"?<div style={{position:"relative",padding:"10px"}}><style>{`.img-btns-outer { position: absolute;
          top: 10px;z-index:999;
          right: 10px; display:flex;justify-content:right;gap:10px}
        .img-btn {
         
          background: rgba(144, 202, 249,1);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          padding: 5px 10px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .img-btn:hover {
          background: rgba(144, 202, 249,0.81);
        }`}</style>
   
   
   <ImageFallFB src={item?.image_presigned_url} 
    border={{}}
                      width={ 100
                      }
                      aspectRatio={1}
                      borderRadius={ {}
                      }/>
                      
                      
                      </div>
                      
                      
                               
                                    :""}
   </> :""}  </div> </div>
  )):
  <></>}

           
   
     
      </div>
     

       </div>  

  
      
                                    
     </>)  
   }
   export default QuestionRichContent;